import { SPACE_ICONS_QUERY_PATH } from '#pplx/frontend/apps/ask/queries/spaces-queries/constants.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
/**
 * Cache key for one icon — the canonical cache unit for space icons. Batch and
 * list responses push-seed these keys (see seedSpaceIcons), and
 * useSpaceIconQuery reads them through the coalescing batcher.
 *
 * Deliberately a bare key builder, not a QueryDefinition: exposing getOptions
 * for the single-GET endpoint would let a direct useQuery consumer bypass the
 * batcher and fan per-icon requests at the server.
 */
export const getSpaceIconKey = (symbolId) => QueryClientHelper.makeQueryKey(SPACE_ICONS_QUERY_PATH, 'symbol', symbolId);
//# sourceMappingURL=getSpaceIconKey.js.map